import React from 'react';
import { Link } from 'react-router-dom';
import { HtmlComponent } from '../../../components';
import { PropTypes } from 'prop-types';
import { BreadcrumbChildSelector } from '.';
import { getRouteToName } from '../../../util';
import classNames from 'classnames';

export const Breadcrumb = ( { child, isLast, node, singleNode } ) => {
  const children = node.children || [];
  const name = <HtmlComponent item={ node } />;
  const fromBreadCrumb = true;
  const childSelector = !children.length || !child ? null : <BreadcrumbChildSelector current={ child } children={ children } />;

  return !isLast
    ? <li key={ node.uuid }>
      <Link to={ getRouteToName( node, fromBreadCrumb ) } >
        { name }
      </Link>
      { childSelector }
    </li>
    : <li key={ node.uuid } className={classNames({"singleNode":singleNode})}>
      { name }
      { childSelector }
    </li>;
};

Breadcrumb.propTypes = {
  child: PropTypes.shape( {
    children: PropTypes.arrayOf( PropTypes.object ),
    parent: PropTypes.object,
    uuid: PropTypes.string
  } ),
  isLast: PropTypes.bool.isRequired,
  node: PropTypes.shape( {
    children: PropTypes.arrayOf( PropTypes.object ),
    parent: PropTypes.object,
    uuid: PropTypes.string
  } )
};